document.addEventListener("DOMContentLoaded", (e) => {
  const addToCartBtn = document.getElementById("pcs-add-to-cart");

  const PRICE_VARIANTS = {
    orientation: [
      { value: "Horizontal", price: 9.95 },
      { value: "Vertical", price: 9.95 },
    ],
    size_qty: [
      { value: "4 Inches QTY 3 (Sample Pack)", price: 0.0 },
      { value: "4 Inches QTY 50", price: 22.0 },
      { value: "4 Inches QTY 100", price: 31.0 },
      { value: "4 Inches QTY 500", price: 124.0 },
      { value: "4 Inches QTY 1000", price: 215.0 },
      { value: "5 Inches QTY 50", price: 41.0 },
      { value: "5 Inches QTY 100", price: 65.0 },
      { value: "5 Inches QTY 500", price: 213.0 },
      { value: "5 Inches QTY 1000", price: 355.0 },
      { value: "6 Inches QTY 50", price: 43.0 },
      { value: "6 Inches QTY 100", price: 82.0 },
      { value: "6 Inches QTY 500", price: 263.0 },
      { value: "6 Inches QTY 1000", price: 457.0 },
    ],
  };

  const state = {
    logoImage: null,
    editedImage: null,
    orientation: null,
    size_qty: "4 Inches QTY 3 (Sample Pack)",
    design_notes: null,
    qr_code_link: null,
    qr_placement: "Left of Logo",
    base_color: "Black",
    left_gradient: "None",
    qr_icon: "None",
    price: 0,
  };

  const DEFAULT_LOGO_URL = "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/default-logo.png";
  const FORMAT_ICONS = {
    pdf: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pdf-file.png",
    ai: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/ai-file.png",
    eps: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/eps-file.png",
    tiff: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/tif-file.png",
    default: DEFAULT_LOGO_URL,
  };
  state.useDefaultLogo = false;
  const NON_EDITABLE_EXTS = ["pdf","ai","eps","tiff","psd"];

  let isFromFinishEditing = false;
  let isOrientationSelected = false;

  /* ---------- helpers ---------- */
  function show(el) {
    el.style.display = "";
  }

  function hide(el) {
    el.style.display = "none";
  }
  function lockScroll() {
    document.documentElement.classList.add('scroll-lock');
    document.body.classList.add('scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('scroll-lock');
    document.body.classList.remove('scroll-lock');
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;

      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  // Handle Product Thumbnails with Orientation
  const orientationVariants = document.querySelectorAll(
    ".orientation-variants__list .sticker-variant"
  );
  const thumbnailButtons = document.querySelectorAll(
    ".product__thumbnail-list-inner .product__thumbnail-item"
  );

  orientationVariants.forEach((variant, index) => {
    variant.addEventListener("click", () => {
      // Trigger click on corresponding thumbnail button
      if (thumbnailButtons[index]) {
        thumbnailButtons[index].click();
      }
      console.log(index);
    });
  });

  /* ---------- QR Code Preview Canvas ----------- */
  const iconMap = {
    None: null,
    Instagram:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/instagram-qr-preview.png?v=1753375041",
    Snapchat:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/snapchat-qr-preview.png?v=1753375835",
    Twitch:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/twitch-qr-preview.png?v=1753376081",
    Facebook:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/facebook-qr-preview.png?v=1753385350",
    YouTube:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/youtube-qr-preview.png?v=1753376281",
    OnlyFans:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/onlyfans-qr-preview.png?v=1753377134",
    "Twitter Bird":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/twitter-bird-qr-preview.png?v=1753377265",
    "Twitter X":
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/twitter-x-qr-preview.png?v=1753377430",
    Pinterest:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/pinterest-qr-preview.png?v=1753377621",
    CashApp:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/cashapp-qr-preview.png?v=1753378195",
    Reddit:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/reddit-qr-preview.png?v=1753383714",
    Discord:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/discord-qr-preview.png?v=1753384045",
    WhatsApp:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/whatsapp-qr-preview.png?v=1753384236",
    WeChat:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/wechat-qr-preview.png?v=1753384334",
    Fansly:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/fansly-qr-preview.png?v=1753384703",
    Telegram:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/telegram-qr-preview.png?v=1753384805",
    Kick: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/kick-qr-preview.png?v=1753385020",
    Rumble:
      "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rumble-qr-preview.png?v=1753385134",
  };

  class QRCodeDesigner {
    constructor() {
      this.canvas = new fabric.Canvas("qr-code-preview", {
        selection: false,
        hoverCursor: "default",
        backgroundColor: "#ffffff",
        allowTouchScrolling: true,
        preserveObjectStacking: true,
        enableRetinaScaling: true,
      });
      this.canvas.upperCanvasEl.style.touchAction = 'auto';
      this.canvas.lowerCanvasEl.style.touchAction = 'auto';
      this.loader = document.createElement("div");
      this.loader.style.cssText =
        "position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.8); display: none; justify-content: center; align-items: center; z-index: 10;";
      this.loader.innerHTML =
        '<div style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite;"></div>';
      this.canvas.wrapperEl.appendChild(this.loader);
      const style = document.createElement("style");
      style.innerHTML =
        "@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }";
      document.head.appendChild(style);
      this.contourObj = null;
      this.orientation = "Horizontal";
      this.qrImage = null;
      this.iconImage = null;
      this.logoImage = null;
      this.gradientRect = null;
      this.baseColor = "#000000";
      this.gradientColor = null;
      this.iconSize = 60;
      this.backgroundPath = null;
      this.clipPath = null;
      this._mergeSeq = 0;
      this._lastLogoURL = null;
      this.colorPalette = {
        Black: "#000000",
        White: "#ffffff",
        "Ice Blue": "#21b3da",
        "Sky Blue": "#0398de",
        "Cobalt Blue": "#1a2a99",
        "Steel Blue": "#00074e",
        "Brimestone Yellow": "#fdf808",
        Yellow: "#fedc00",
        "Golden Yellow": "#ffb400",
        "Pastel Orange": "#ff7110",
        Orange: "#fe7305",
        "Orange Red": "#f63700",
        Red: "#c70203",
        "Dark Red": "#960a03",
        Burgundy: "#5a111d",
        "Dark Gray": "#818181",
        Mint: "#22d095",
        Turquoise: "#01979b",
        "Lime Tea Green": "#52b12f",
        "Yellow Green": "#4a9e2c",
        Green: "#039049",
        "Forest Green": "#03370b",
        "Dark Green": "#002905",
        Lilac: "#dc89a5",
        Lavender: "#904e8b",
        Violet: "#721a44",
        Purple: "#711953",
        "Purple Red": "#8c102e",
        "Soft Pink": "#e66b87",
        "Bright Pink": "#f62b56",
        Cream: "#fbdc81",
        Beige: "#d8bd78",
        "Light Brown": "#c16b38",
        "Nut Brown": "#a93f18",
        Brown: "#350b05",
      };
      this.handleResize();
      this.bindEvents();
      this.init();
      this.debounceRender = this.debounce(() => {
        this.canvas.renderAll();
      }, 100);
      window.addEventListener("scroll", this.debounceRender);
      this.debounceTouchMove = this.debounce(() => {
        this.canvas.renderAll();
      }, 50);
      document.addEventListener("touchmove", this.debounceTouchMove, { passive: true });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.canvas.renderAll();
          }
        });
      });
      observer.observe(this.canvas.wrapperEl);
      this.debouncedHandleResize = this.debounce(this.handleResize.bind(this), 100);
    }
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    showLoader() {
      if (this.loader) {
        this.loader.style.display = "flex";
      }
    }
    hideLoader() {
      if (this.loader) {
        this.loader.style.display = "none";
      }
    }
    handleResize() {
      let baseSize;
      if (window.innerWidth < 375) {
        baseSize = 250;
      } else if (window.innerWidth <= 475) {
        baseSize = 300;
      } else {
        baseSize = 400;
      }
      if (this.orientation === "Horizontal") {
        this.canvas.setDimensions({ width: baseSize, height: baseSize / 2 });
      } else {
        this.canvas.setDimensions({ width: baseSize / 2, height: baseSize });
      }
      this.updatePositions();
      requestAnimationFrame(() => this.canvas.renderAll());
    }
    async init() {
      const qrURL =
        "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/qr-code-image.png";
      const qrURLFilled = "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/qr-code-image-filled.png";
      this.qrImage = await this.loadImage(qrURLFilled);
      this.qrImage.set({
        originX: "center",
        originY: "center",
        selectable: false,
        evented: false,
        stroke: null,
        strokeWidth: 0,
        shadow: null,
        objectCaching: false,
      });
      this.canvas.add(this.qrImage);
      await this.loadLogo();
      await this.mergeQRAndLogo();
      this.updatePositions();
    }
    getIconSize() {
      if (!this.qrImage) return 60;
      const qrSize = Math.min(
        this.qrImage.getScaledWidth(),
        this.qrImage.getScaledHeight()
      );
      return qrSize * 0.2;
    }
    async loadImage(url) {
      return new Promise((resolve) => {
        fabric.Image.fromURL(url, (img) => resolve(img), {
          crossOrigin: "anonymous",
        });
      });
    }
    async loadLogo() {
      if (this.logoImage) {
        this.canvas.remove(this.logoImage);
        this.logoImage = null;
      }
      if (this._lastLogoURL && this._lastLogoURL.startsWith('blob:')) {
        try { URL.revokeObjectURL(this._lastLogoURL); } catch (_) {}
        this._lastLogoURL = null;
      }
      let imgSourceUrl = (!state.useDefaultLogo) ? (state.editedImage || state.logoImage) : null;
      imgSourceUrl = imgSourceUrl ? URL.createObjectURL(imgSourceUrl) : DEFAULT_LOGO_URL;
      if (imgSourceUrl) this._lastLogoURL = imgSourceUrl;
      this.logoImage = await this.loadImage(imgSourceUrl);
      this.logoImage.set({
        originX: "center",
        originY: "center",
        selectable: false,
        evented: false,
        objectCaching: false,
        stroke: null,
        strokeWidth: 0,
        shadow: null,
      });
      if (this.clipPath) this.logoImage.clipPath = this.clipPath;
      this.canvas.add(this.logoImage);
      await this.analyzeAndApplyLogoColors(imgSourceUrl);
      this.updatePositions();
      requestAnimationFrame(() => this.canvas.renderAll());
    }
    async analyzeAndApplyLogoColors(imageUrl) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imageUrl;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          const imageData = ctx.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          ).data;
          const colorCounts = {};
          for (let i = 0; i < imageData.length; i += 40) {
            const r = imageData[i];
            const g = imageData[i + 1];
            const b = imageData[i + 2];
            const a = imageData[i + 3];
            if (a < 128) continue;
            const color = `rgb(${r},${g},${b})`;
            colorCounts[color] = (colorCounts[color] || 0) + 1;
          }
          const sortedColors = Object.entries(colorCounts).sort(
            (a, b) => b[1] - a[1]
          );
          let dominantColor = null;
          const brightnessThreshold = 180;
          for (const [color] of sortedColors) {
            const rgb = color.match(/\d+/g).map(Number);
            const brightness = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114;
            if (brightness < brightnessThreshold) {
              dominantColor = color;
              break;
            }
          }
          if (!dominantColor && sortedColors.length > 0) {
            dominantColor = sortedColors[0][0];
          }
          if (dominantColor) {
            const hex = this.rgbToHex(dominantColor);
            let baseColorMatch = this.findClosestPaletteColor(hex);
            const baseRgb = this.hexToRgb(this.colorPalette[baseColorMatch]);
            const baseBrightness =
              baseRgb.r * 0.299 + baseRgb.g * 0.587 + baseRgb.b * 0.114;
            if (baseBrightness >= brightnessThreshold) {
              baseColorMatch = "Black";
            }
            this.baseColor = this.colorPalette[baseColorMatch];
            this.selectDropdownOption("base-color-select", baseColorMatch);
            state.base_color = baseColorMatch;
            const gradientColorMatch = this.findGradientColorMatch(baseColorMatch);
            this.gradientColor = gradientColorMatch
              ? this.colorPalette[gradientColorMatch]
              : null;
            if (gradientColorMatch) {
              this.selectDropdownOption(
                "left-gradient-select",
                gradientColorMatch
              );
              state.left_gradient = gradientColorMatch;
            } else {
              this.selectDropdownOption("left-gradient-select", "None");
              state.left_gradient = "None";
            }
            this.applyGradient();
          } else {
            const baseColorMatch = "Black";
            this.baseColor = this.colorPalette[baseColorMatch];
            this.selectDropdownOption("base-color-select", baseColorMatch);
            state.base_color = baseColorMatch;
            this.selectDropdownOption("left-gradient-select", "None");
            state.left_gradient = "None";
            this.applyGradient();
          }
          resolve();
        };
        img.onerror = () => resolve();
      });
    }
    findClosestPaletteColor(hexColor) {
      if (!hexColor) return "Black";
      const targetRgb = this.hexToRgb(hexColor);
      if (!targetRgb) return "Black";
      let closestColor = "Black";
      let minDistance = Infinity;
      for (const [colorName, colorHex] of Object.entries(this.colorPalette)) {
        if (colorName === "White") continue;
        const paletteRgb = this.hexToRgb(colorHex);
        const distance = this.colorDistance(targetRgb, paletteRgb);
        if (distance < minDistance) {
          minDistance = distance;
          closestColor = colorName;
        }
      }
      return closestColor;
    }
    findGradientColorMatch(baseColorName) {
      const baseColorHex = this.colorPalette[baseColorName];
      const baseRgb = this.hexToRgb(baseColorHex);
      if (baseColorName === "White") {
        return null;
      }
      let lightestDistance = Infinity;
      let lightestMatch = null;
      let complementaryDistance = Infinity;
      let complementaryMatch = null;
      for (const [colorName, colorHex] of Object.entries(this.colorPalette)) {
        if (colorName === baseColorName || colorName === "White") continue;
        const currentRgb = this.hexToRgb(colorHex);
        const distance = this.colorDistance(baseRgb, currentRgb);
        if (this.isLighterColor(currentRgb, baseRgb)) {
          if (distance < lightestDistance) {
            lightestDistance = distance;
            lightestMatch = colorName;
          }
        }
        if (distance > 150) {
          if (distance < complementaryDistance) {
            complementaryDistance = distance;
            complementaryMatch = colorName;
          }
        }
      }
      return lightestMatch || complementaryMatch || "Black";
    }
    isLighterColor(color1, color2) {
      const brightness1 =
        (color1.r * 299 + color1.g * 587 + color1.b * 114) / 1000;
      const brightness2 =
        (color2.r * 299 + color2.g * 587 + color2.b * 114) / 1000;
      return brightness1 > brightness2;
    }
    selectDropdownOption(dropdownId, value) {
      const dropdown = document.getElementById(dropdownId);
      if (!dropdown) return;
      const options = dropdown.querySelectorAll("li[data-value]");
      let foundOption = null;
      options.forEach((option) => {
        if (option.dataset.value === value) {
          foundOption = option;
        }
      });
      if (foundOption) {
        options.forEach((option) => option.classList.remove("selected"));
        foundOption.classList.add("selected");
        const selectedText = dropdown.querySelector(".selected-text");
        if (selectedText) {
          selectedText.textContent = foundOption.textContent.trim();
        }
        dropdown.classList.add("variant-picked");
      }
    }
    hexToRgb(hex) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    }
    colorDistance(rgb1, rgb2) {
      return Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
          Math.pow(rgb1.g - rgb2.g, 2) +
          Math.pow(rgb1.b - rgb2.b, 2)
      );
    }
    bindEvents() {
      $("#base-color-select li").on("click", (e) => {
        const hex = $(e.currentTarget)
          .find(".color-swatch")
          .css("background-color");
        this.baseColor = this.rgbToHex(hex);
        this.applyGradient();
        this.mergeQRAndLogo();
      });
      $("#left-gradient-select li").on("click", (e) => {
        const hex = $(e.currentTarget)
          .find(".color-swatch")
          .css("background-color");
        const val = $(e.currentTarget).data("value");
        this.gradientColor = val === "None" ? null : this.rgbToHex(hex);
        this.applyGradient();
        this.mergeQRAndLogo();
      });
      $("#qr-icon-select li").on("click", async (e) => {
        const iconName = $(e.currentTarget).data("value");
        await this.updateIcon(iconName);
      });
      document
        .getElementById("orientation-variant")
        .addEventListener("click", (e) => {
          const selected = e.target.closest(".sticker-variant");
          if (selected) {
            this.orientation = selected.dataset.orientation;
            this.updateOrientation(this.orientation);
          }
          this.mergeQRAndLogo();
        });
      window.addEventListener("resize", this.debouncedHandleResize);
    }
    async updateOrientation(orientation) {
      this.orientation = orientation;
      if (state.editedImage || state.logoImage) {
        await this.loadLogo();
      }
      if (this.iconImage) {
        const iconSize = this.getIconSize();
        this.iconImage.scaleToWidth(iconSize);
      }
      this.handleResize();
      this.mergeQRAndLogo();
    }
    updatePositions() {
      if (!this.qrImage) return;
      const elementGap = 0;
      const padding = 20;
      const canvasW = this.canvas.width;
      const canvasH = this.canvas.height;
      this.qrImage.lockUniScaling = true;
      if (this.logoImage) this.logoImage.lockUniScaling = true;
      if (this.iconImage) this.iconImage.lockUniScaling = true;
      this.qrImage.set({ originX: "center", originY: "center" });
      if (this.logoImage)
        this.logoImage.set({ originX: "center", originY: "center" });
      if (this.iconImage)
        this.iconImage.set({ originX: "center", originY: "center" });
      let qrWidth = 0,
        qrHeight = 0;
      let logoWidth = 0,
        logoHeight = 0;
      if (this.orientation === "Horizontal") {
        const availableHeight = canvasH - padding * 2;
        this.qrImage.scaleToHeight(availableHeight);
        qrWidth = this.qrImage.getScaledWidth();
        qrHeight = this.qrImage.getScaledHeight();
        if (this.logoImage) {
          this.logoImage.scaleToHeight(availableHeight);
          logoWidth = this.logoImage.getScaledWidth();
          logoHeight = this.logoImage.getScaledHeight();
        }
        const totalWidth =
          qrWidth + (this.logoImage ? logoWidth + elementGap : 0);
        const maxWidth = canvasW - padding * 2;
        if (totalWidth > maxWidth) {
          const scaleFactor = maxWidth / totalWidth;
          this.qrImage.scale(this.qrImage.scaleX * scaleFactor);
          qrWidth = this.qrImage.getScaledWidth();
          qrHeight = this.qrImage.getScaledHeight();
          if (this.logoImage) {
            this.logoImage.scale(this.logoImage.scaleX * scaleFactor);
            logoWidth = this.logoImage.getScaledWidth();
            logoHeight = this.logoImage.getScaledHeight();
          }
        }
        const y = canvasH / 2;
        let qrX, logoX;
        if (!this.logoImage) {
          qrX = canvasW / 2;
        } else {
          const contentW = qrWidth + logoWidth + elementGap;
          const startX = (canvasW - contentW) / 2;
          if (state.qr_placement === "Left of Logo") {
            qrX = startX + qrWidth / 2;
            logoX = qrX + qrWidth / 2 + elementGap + logoWidth / 2;
          } else {
            logoX = startX + logoWidth / 2;
            qrX = logoX + logoWidth / 2 + elementGap + qrWidth / 2;
          }
        }
        this.qrImage
          .set({ left: Math.floor(qrX) + 0.5, top: Math.floor(y) + 0.5 })
          .setCoords();
        if (this.logoImage) {
          this.logoImage
            .set({ left: Math.floor(logoX) + 0.5, top: Math.floor(y) + 0.5 })
            .setCoords();
        }
      } else {
        const availableWidth = canvasW - padding * 2;
        this.qrImage.scaleToWidth(availableWidth);
        qrWidth = this.qrImage.getScaledWidth();
        qrHeight = this.qrImage.getScaledHeight();
        if (this.logoImage) {
          this.logoImage.scaleToWidth(availableWidth);
          logoWidth = this.logoImage.getScaledWidth();
          logoHeight = this.logoImage.getScaledHeight();
        }
        const totalHeight =
          qrHeight + (this.logoImage ? logoHeight + elementGap : 0);
        const maxHeight = canvasH - padding * 2;
        if (totalHeight > maxHeight) {
          const scaleFactor = maxHeight / totalHeight;
          const targetWidth = availableWidth * scaleFactor;
          this.qrImage.scaleToWidth(targetWidth);
          qrWidth = this.qrImage.getScaledWidth();
          qrHeight = this.qrImage.getScaledHeight();
          if (this.logoImage) {
            this.logoImage.scaleToWidth(targetWidth);
            logoWidth = this.logoImage.getScaledWidth();
            logoHeight = this.logoImage.getScaledHeight();
          }
        }
        const x = canvasW / 2;
        let qrY, logoY;
        if (!this.logoImage) {
          qrY = canvasH / 2;
        } else {
          const contentH = qrHeight + logoHeight + elementGap;
          const startY = (canvasH - contentH) / 2;
          if (state.qr_placement === "Below Logo") {
            logoY = startY + logoHeight / 2;
            qrY = logoY + logoHeight / 2 + elementGap + qrHeight / 2;
          } else {
            qrY = startY + qrHeight / 2;
            logoY = qrY + qrHeight / 2 + elementGap + logoHeight / 2;
          }
        }
        this.qrImage
          .set({ left: Math.floor(x) + 0.5, top: Math.floor(qrY) + 0.5 })
          .setCoords();
        if (this.logoImage) {
          this.logoImage
            .set({ left: Math.floor(x) + 0.5, top: Math.floor(logoY) + 0.5 })
            .setCoords();
        }
      }
      if (this.iconImage) {
        const iconSize = this.getIconSize();
        this.iconImage.scaleToWidth(iconSize);
        this.iconImage
          .set({
            left: this.qrImage.left,
            top: this.qrImage.top,
          })
          .setCoords();
      }
      this.applyGradient();
      this.canvas.bringToFront(this.qrImage);
      if (this.logoImage) this.canvas.bringToFront(this.logoImage);
      if (this.iconImage) this.canvas.bringToFront(this.iconImage);
      requestAnimationFrame(() => this.canvas.renderAll());
    }
    applyGradient() {
      if (this.gradientRect) {
        this.canvas.remove(this.gradientRect);
      }
      const qrW = this.qrImage.getScaledWidth() - 2;
      const qrH = this.qrImage.getScaledHeight() - 2;
      const gradientCoords =
        this.orientation === "Horizontal"
          ? { x1: 0, y1: 0, x2: qrW, y2: 0 }
          : { x1: 0, y1: 0, x2: 0, y2: qrH };
      const gradientFill = new fabric.Gradient({
        type: "linear",
        coords: gradientCoords,
        colorStops: [
          { offset: 0, color: this.gradientColor || this.baseColor },
          { offset: 1, color: this.baseColor },
        ],
      });
      this.gradientRect = new fabric.Rect({
        left: this.qrImage.left - qrW / 2,
        top: this.qrImage.top - qrH / 2,
        width: qrW,
        height: qrH,
        fill: gradientFill,
        stroke: "#ffffff",
        strokeWidth: 1,
        strokeUniform: true,
        shadow: false,
        selectable: false,
        evented: false,
        objectCaching: false,
      });
      if (this.clipPath) {
        this.gradientRect.clipPath = this.clipPath;
      }
      this.canvas.insertAt(this.gradientRect, 0);
      if (this.backgroundPath) {
        this.canvas.sendToBack(this.backgroundPath);
      }
      this.canvas.bringToFront(this.qrImage);
      if (this.iconImage) this.canvas.bringToFront(this.iconImage);
      requestAnimationFrame(() => this.canvas.renderAll());
    }
    async updateIcon(iconName) {
      const qrURL = "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/qr-code-image.png";
      const qrURLFilled = "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/qr-code-image-filled.png";

      // Show loader immediately
      this.showLoader();

      // Record the start time
      const startTime = Date.now();

      if (this.iconImage) {
        this.canvas.remove(this.iconImage);
        this.iconImage = null;
      }

      const qrImageUrl = iconName === "None" ? qrURLFilled : qrURL;
      if (this.qrImage && this.qrImage._originalElement?.src !== qrImageUrl) {
        this.canvas.remove(this.qrImage);
        this.qrImage = await this.loadImage(qrImageUrl);
        this.qrImage.set({
          originX: "center",
          originY: "center",
          selectable: false,
          evented: false,
          stroke: null,
          strokeWidth: 0,
          shadow: null,
          objectCaching: false,
        });
        this.canvas.add(this.qrImage);
      }

      if (!iconName || iconName === "None") {
        this.updatePositions();
        this.applyGradient();
        this.canvas.renderAll();
      } else {
        const iconURL = iconMap[iconName];
        if (!iconURL) {
          this.updatePositions();
          this.applyGradient();
          this.canvas.renderAll();
        } else {
          try {
            const icon = await this.loadImage(iconURL);
            const iconSize = this.getIconSize();
            icon.scaleToWidth(iconSize);
            icon.set({
              originX: "center",
              originY: "center",
              left: this.qrImage.left,
              top: this.qrImage.top,
              selectable: true,
              evented: true,
              hasControls: false,
              stroke: null,
              objectCaching: false,
            });
            if (this.clipPath) {
              icon.clipPath = this.clipPath;
            }
            this.iconImage = icon;
            this.canvas.add(icon);
            this.canvas.bringToFront(icon);
            this.updatePositions();
            this.applyGradient();
          } catch (error) {
            console.error("Error loading icon:", error);
            this.showError("Error loading icon. Please try again.");
          }
        }
      }

      // Ensure loader is shown for at least 1 second
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, 1000 - elapsedTime);
      setTimeout(() => {
        this.hideLoader();
        requestAnimationFrame(() => this.canvas.renderAll());
      }, remainingTime);
    }
    rgbToHex(rgb) {
      if (!rgb) return "#000000";
      const rgbValues = rgb.match(/\d+/g);
      if (!rgbValues || rgbValues.length < 3) return "#000000";
      const [r, g, b] = rgbValues;
      return `#${(
        (1 << 24) +
        (parseInt(r) << 16) +
        (parseInt(g) << 8) +
        parseInt(b)
      )
        .toString(16)
        .slice(1)}`;
    }
    async mergeQRAndLogo() {
      console.log("mergeQRAndLogo called");
      if (!this.qrImage) {
        console.error("QR code image is required for merging.");
        return;
      }
      if (!this.logoImage) {
        await this.loadLogo();
      }
      if (this.contourObj) {
        this.canvas.remove(this.contourObj);
        this.contourObj = null;
        this.canvas.renderAll();
      }
      this.showLoader();
      try {
        this.updatePositions();
        const tempCanvas = document.createElement("canvas");
        const ctx = tempCanvas.getContext("2d");
        const gap = 0;
        const qrWidth = this.qrImage.getScaledWidth();
        const qrHeight = this.qrImage.getScaledHeight();
        const logoWidth = this.logoImage ? this.logoImage.getScaledWidth() : 0;
        const logoHeight = this.logoImage ? this.logoImage.getScaledHeight() : 0;
        let canvasWidth, canvasHeight, qrX, qrY, logoX, logoY;
        if (!this.logoImage) {
          canvasWidth = qrWidth;
          canvasHeight = qrHeight;
          qrX = 0;
          qrY = 0;
        } else if (this.orientation === "Horizontal") {
          canvasWidth = qrWidth + logoWidth + gap;
          canvasHeight = Math.max(qrHeight, logoHeight);
          if (state.qr_placement === "Left of Logo") {
            qrX = 0;
            qrY = (canvasHeight - qrHeight) / 2;
            logoX = qrWidth + gap;
            logoY = (canvasHeight - logoHeight) / 2;
          } else {
            logoX = 0;
            logoY = (canvasHeight - logoHeight) / 2;
            qrX = logoWidth + gap;
            qrY = (canvasHeight - qrHeight) / 2;
          }
        } else {
          canvasWidth = Math.max(qrWidth, logoWidth);
          canvasHeight = qrHeight + logoHeight + gap;
          if (state.qr_placement === "Below Logo") {
            logoX = (canvasWidth - logoWidth) / 2;
            logoY = 0;
            qrX = (canvasWidth - qrWidth) / 2;
            qrY = logoHeight + gap;
          } else {
            qrX = (canvasWidth - qrWidth) / 2;
            qrY = 0;
            logoX = (canvasWidth - logoWidth) / 2;
            logoY = qrHeight + gap;
          }
        }
        tempCanvas.width = canvasWidth;
        tempCanvas.height = canvasHeight;
        const qrCanvas = this.qrImage.toCanvasElement({ multiplier: 1 });
        ctx.drawImage(qrCanvas, qrX, qrY, qrWidth, qrHeight);
        if (this.logoImage) {
          const logoCanvas = this.logoImage.toCanvasElement({ multiplier: 1 });
          ctx.drawImage(logoCanvas, logoX, logoY, logoWidth, logoHeight);
        }
        const blob = await new Promise((resolve) => {
          tempCanvas.toBlob(resolve, "image/png");
        });
        const formData = new FormData();
        formData.append("image", blob, "merged-qr-logo.png");
        const response = await fetch(
          "https://api.vulgrco.com/generate-simple-clippath",
          {
            method: "POST",
            body: formData,
          }
        );
        if (!response.ok) {
          throw new Error(`Server responded with ${response.status}`);
        }
        const svgContent = await response.json();
        const svgString = svgContent.svg_content;
        if (!svgString) {
          this.showError("Failed to generate contour. Please try again.");
          return;
        }
        fabric.loadSVGFromString(svgString, (objects, options) => {
          const contourObj = fabric.util.groupSVGElements(objects, options);
          this.contourObj = contourObj;
          contourObj.set({
            selectable: false,
            evented: false,
            fill: "transparent",
            fillRule: "evenodd",
            stroke: "#ec008c",
            strokeWidth: 1,
            strokeUniform: true,
            shadow: {
              color: "rgba(0, 0, 0, 0.42)",
              blur: 20,
              offsetX: 4,
              offsetY: 4,
            },
            objectCaching: false,
          });
          this.canvas.clear();
          this.canvas.add(this.gradientRect);
          this.canvas.add(contourObj);
          this.canvas.add(this.qrImage);
          if (this.logoImage) {
            this.canvas.add(this.logoImage);
          }
          if (this.iconImage) {
            this.canvas.add(this.iconImage);
          }
          this.updatePositions();
          this.applyGradient();
          this.alignContourAndImage(contourObj, this.qrImage, this.logoImage);
          this.canvas.sendToBack(contourObj);
          this.canvas.bringToFront(this.qrImage);
          if (this.logoImage) this.canvas.bringToFront(this.logoImage);
          if (this.iconImage) this.canvas.bringToFront(this.iconImage);
          requestAnimationFrame(() => this.canvas.renderAll());
        });
      } catch (err) {
        console.error("Error processing or sending image:", err);
        this.showError("Error generating sticker preview. Please try again.");
      } finally {
        this.hideLoader();
      }
    }
    alignContourAndImage(contourObj, qrImage, logoImage) {
      if (!contourObj || !qrImage) return;
      contourObj.scale(1).setCoords();
      const qrBounds = qrImage.getBoundingRect(true);
      const elementGap = 0;
      const marginPercent = 0.1;
      let totalLeft, totalTop, totalWidth, totalHeight;
      if (!logoImage) {
        totalLeft = qrBounds.left;
        totalTop = qrBounds.top;
        totalWidth = qrBounds.width;
        totalHeight = qrBounds.height;
      } else {
        const logoBounds = logoImage.getBoundingRect(true);
        if (this.orientation === "Horizontal") {
          if (state.qr_placement === "Left of Logo") {
            totalLeft = Math.min(qrBounds.left, logoBounds.left);
            totalWidth =
              logoBounds.left + logoBounds.width - qrBounds.left + elementGap;
          } else {
            totalLeft = Math.min(logoBounds.left, qrBounds.left);
            totalWidth =
              qrBounds.left + qrBounds.width - logoBounds.left + elementGap;
          }
          totalTop = Math.min(qrBounds.top, logoBounds.top);
          totalHeight = Math.max(qrBounds.height, logoBounds.height);
        } else {
          totalLeft = Math.min(qrBounds.left, logoBounds.left);
          totalWidth = Math.max(qrBounds.width, logoBounds.width);
          if (state.qr_placement === "Below Logo") {
            totalTop = Math.min(logoBounds.top, qrBounds.top);
            totalHeight =
              qrBounds.top + qrBounds.height - logoBounds.top + elementGap;
          } else {
            totalTop = Math.min(qrBounds.top, logoBounds.top);
            totalHeight =
              logoBounds.top + logoBounds.height - qrBounds.top + elementGap;
          }
        }
      }
      const contourBounds = contourObj.getBoundingRect(true);
      const contourW = contourBounds.width || 1;
      const contourH = contourBounds.height || 1;
      const targetW = totalWidth * (1 + marginPercent);
      const targetH = totalHeight * (1 + marginPercent);
      const maxCanvasScale = Math.min(
        this.canvas.width / totalWidth,
        this.canvas.height / totalHeight
      );
      const contourScale = Math.min(
        targetW / contourW,
        targetH / contourH,
        maxCanvasScale * 0.9
      );
      contourObj.scale(contourScale).setCoords();
      const combinedCenterX = totalLeft + totalWidth / 2;
      const combinedCenterY = totalTop + totalHeight / 2;
      contourObj
        .set({
          originX: "center",
          originY: "center",
          left: combinedCenterX,
          top: combinedCenterY,
        })
        .setCoords();
      const images = [qrImage];
      if (logoImage) images.push(logoImage);
      images.forEach((img) => {
        img.setCoords();
      });
    }
    clearLogo() {
      if (this.logoImage) {
        this.canvas.remove(this.logoImage);
        this.logoImage = null;
      }
      if (this.backgroundPath) {
        this.canvas.remove(this.backgroundPath);
        this.backgroundPath = null;
      }
      if (this.clipPath) {
        this.canvas.remove(this.clipPath);
        this.clipPath = null;
      }
      if (this.contourObj) {
        this.canvas.remove(this.contourObj);
        this.contourObj = null;
      }
      this.updatePositions();
      requestAnimationFrame(() => this.canvas.renderAll());
    }
    destroy() {
      this.clearLogo();
      this.canvas.dispose();
      this.qrImage = null;
      this.iconImage = null;
      this.logoImage = null;
      this.gradientRect = null;
      this.backgroundPath = null;
      this.clipPath = null;
      window.removeEventListener("scroll", this.debounceRender);
      document.removeEventListener("touchmove", this.debounceTouchMove);
      window.removeEventListener("resize", this.debouncedHandleResize);
    }
    showError(message) {
      const msgEl = $("#canvasMessage");
      msgEl.removeClass("warning").addClass("error").text(message).fadeIn();
    }
    rasterizeFullCanvas() {
      const dataURL = this.canvas.toDataURL({
        format: 'png',
        multiplier: window.devicePixelRatio || 1
      });
      this.canvas.wrapperEl.style.display = 'none';
      let previewImg = this.canvas.wrapperEl.querySelector('img.preview-img');
      if (!previewImg) {
        previewImg = document.createElement('img');
        previewImg.className = 'preview-img';
        previewImg.style.width = '100%';
        previewImg.style.height = 'auto';
        this.canvas.wrapperEl.appendChild(previewImg);
      }
      previewImg.src = dataURL;
    }
}

  const qrDesigner = new QRCodeDesigner();

  const addQrCodeBtn = document.getElementById("add-qr-code-btn");
  const horizontalQrCodeFields = document.getElementById(
    "horizontal-qr-code-fields"
  );
  const artworkQrCodeVariant = document.getElementById(
    "artwork-qr-code-variant"
  );
  addQrCodeBtn.addEventListener("click", async (e) => {
    horizontalQrCodeFields.style.display = "block";
    artworkQrCodeVariant.style.display = "none";
    qrDesigner.clearLogo();
    await qrDesigner.mergeQRAndLogo();
  });

  /* ---------- Orientation Selection ---------- */
  function setupOrientationSelection() {
    const orientationWrapper = document.getElementById("orientation-variant");
    const showBlocksIds = [
      "artwork-variant",
      "horizontal-logo-fields",
      "artwork-qr-code-variant",
    ];

    orientationWrapper.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      const QRCodeContainer = document.getElementById("qr-code-container");
      if (!selected) return;

      // visuals
      orientationWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
        el.classList.toggle("variant-picked", el === selected);
      });

      if (!isOrientationSelected) {
        showBlocksIds.forEach(
          (el) => (document.getElementById(el).style.display = "block")
        );
        $("#pcs-add-to-cart").prop("disabled", false);
        isOrientationSelected = true;
      }

      // state
      state.orientation = selected.dataset.orientation;
      console.log("Orientation updated to:", state.orientation);

      if (state.orientation == "Horizontal") {
        QRCodeContainer.classList.add("orientation--horizontal");
        QRCodeContainer.classList.remove("orientation--vertical");
      } else {
        QRCodeContainer.classList.remove("orientation--horizontal");
        QRCodeContainer.classList.add("orientation--vertical");
      }

      // Update QR Code Placement options based on orientation
      updateQRPlacementOptions(state.orientation);

      // Scroll Logo Box
      const targetElement = document.getElementById("horizontal-logo-fields");
      const artworkVariant = document.querySelector(
        "#artwork-variant .artwork-box"
      );
      const chooseFileBtn = document.getElementById("choose-file-btn");
      const stickyHeaderOffset = -83;
      const targetScrollPosition =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset +
        stickyHeaderOffset;
      window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });

      blinkVariantElement(artworkVariant);

      if (chooseFileBtn.classList.contains("shine")) {
        chooseFileBtn.classList.remove("shine");
      }
      setTimeout(() => {
        chooseFileBtn.classList.add("shine");
      }, 500);

      recalcPrice();
    });
  }

  // New function to update QR Placement options
  function updateQRPlacementOptions(orientation) {
    const qrPlacementWrapper = document.querySelector(
      "#qr-code-placement-variant .sticker-variants__list"
    );
    const gradientVariant = document.getElementById("left-gradient-variant");

    if (orientation === "Horizontal") {
      // Update QR placement options
      qrPlacementWrapper.innerHTML = `
      <div class="sticker-variant active" data-placement="Left of Logo">
        <p>Left of Logo</p>
      </div>
      <div class="sticker-variant" data-placement="Right of Logo">
        <p>Right of Logo</p>
      </div>
    `;

      // Update gradient variant label
      gradientVariant.querySelector("h4").textContent =
        "Left Gradient Color (OPTIONAL)";
      gradientVariant.querySelector("p").textContent =
        "Please choose left gradient color if desired. Only choose white QR color if your logo's background is a color other than white. White will be swapped for Black if the QR is fully/partially invisible.";

      // Update state to default for horizontal
      state.qr_placement = "Left of Logo";
    } else if (orientation === "Vertical") {
      // Update QR placement options
      qrPlacementWrapper.innerHTML = `
      <div class="sticker-variant active" data-placement="Above Logo">
        <p>Above Logo</p>
      </div>
      <div class="sticker-variant" data-placement="Below Logo">
        <p>Below Logo</p>
      </div>
    `;

      // Update gradient variant label
      gradientVariant.querySelector("h4").textContent =
        "Top Gradient Color (OPTIONAL)";
      gradientVariant.querySelector("p").textContent =
        "Please choose top gradient color if desired. Only choose white QR color if your logo's background is a color other than white. White will be swapped for Black if the QR is fully/partially invisible.";

      // Update state to default for vertical
      state.qr_placement = "Above Logo";
    }

    // Re-bind the click event handlers for the new options
    setupQRPlacementSelection();
  }

  /* ---------- Initial dropdown setup ------------------------------------ */
  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      // If an <li data-value> is pre-selected via .selected, copy to header
      const preSel = dd.querySelector("li.selected");
      if (preSel) {
        dd.querySelector(".selected-text").textContent = preSel.textContent;
        // dd.classList.add("variant-picked");
      }
    });
  }

  /* ---------- Single delegated click-handler -------------------- */
  function dropdownClickHandler(evt) {
    /* A. find the dropdown wrapper (if any) --------------------------- */
    const dropdown = evt.target.closest(".select-dropdown");

    /* B. click happened outside every dropdown  → close all & exit ---- */
    if (!dropdown) {
      document
        .querySelectorAll(".dropdown-options")
        .forEach((list) => (list.style.display = "none"));
      return;
    }

    const list = dropdown.querySelector(".dropdown-options");
    const header = dropdown.querySelector(".selected-text");
    const stateKey = dropdown.dataset.stateKey;
    const optionEl = evt.target.closest("li[data-value]");

    /* C. close every other open list, keep this one intact ------------ */
    document.querySelectorAll(".dropdown-options").forEach((other) => {
      if (other !== list) other.style.display = "none";
    });

    /* D. user clicked an <li> option ---------------------------------- */
    if (optionEl) {
      const value = optionEl.dataset.value;

      list
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("selected"));
      optionEl.classList.add("selected");
      header.textContent = optionEl.textContent;

      // ✅ Only add 'variant-picked' if value is not "None"
      if (value.trim().toLowerCase() !== "none") {
        dropdown.classList.add("variant-picked");
      } else {
        dropdown.classList.remove("variant-picked");
      }

      if (stateKey) state[stateKey] = value; // sync shared state

      /* Clear error for this variant */
      const variantBox = dropdown.closest(".pcs-variant");
      if (variantBox) {
        variantBox.classList.remove("has-error");
        const errorBar = variantBox.querySelector(".error-bar");
        if (errorBar) errorBar.style.display = "none";
      }

      list.style.display = "none";
      console.log(state);
      recalcPrice();
      return;
    }

    /* E. user clicked header/arrow  → toggle this list ---------------- */
    list.style.display = list.style.display === "block" ? "none" : "block";
  }

  /* -------- design notes input / counter / state --------------------- */
  function handleDesignNotesInput() {
    const input = document.getElementById("design-notes-input");
    if (!input || input.dataset.listenerAttached) return;
    input.dataset.listenerAttached = "true";

    const counter = document.getElementById("design-notes-char-count");
    const error = document.getElementById("design-notes-error-bar");

    const MAX = 1000;

    const refresh = () => {
      const value = input.value;
      state.design_notes = value;
      counter.textContent = `${MAX - value.length} character(s) left`;
      error.style.display = "none";
      console.log(state);
    };

    refresh();
    input.addEventListener("input", refresh);

    input.addEventListener("keyup", () => {
      const designNoteWrapper = document.querySelector(
        "#design-notes-variant .input-field-wrapper"
      );
      designNoteWrapper.classList.toggle(
        "variant-picked",
        input.value.trim() !== ""
      );
    });

    // Scroll on blur if input has content
    input.addEventListener("blur", () => {
      if (input.value.trim() !== "") {
        const qrArtworkBox = document.getElementById("qr-artwork-box");
        const qrCodeContainer = document.getElementById("qr-code-container");
        const addQrCodeBtn = document.getElementById("add-qr-code-btn");

        // Check if qrArtworkBox is effectively hidden
        const isHiddenQrArtworkBox =
          getComputedStyle(qrArtworkBox).display === "none" ||
          !qrArtworkBox.offsetParent;
        if (!isHiddenQrArtworkBox) {
          const targetElement = document.getElementById(
            "artwork-qr-code-variant"
          );
          const stickyHeaderOffset = -81;
          const targetScrollPosition =
            targetElement.getBoundingClientRect().top +
            window.pageYOffset +
            stickyHeaderOffset;
          window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });
          blinkVariantElement(qrArtworkBox);
        } else {
          const targetElement = document.getElementById(
            "horizontal-qr-code-fields"
          );
          const stickyHeaderOffset = -81;
          const targetScrollPosition =
            targetElement.getBoundingClientRect().top +
            window.pageYOffset +
            stickyHeaderOffset;
          window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });
          blinkVariantElement(qrCodeContainer);
        }
        if (addQrCodeBtn.classList.contains("shine")) {
          addQrCodeBtn.classList.remove("shine");
        }
        setTimeout(() => {
          addQrCodeBtn.classList.add("shine");
        }, 500);
      }
    });
  }

  /* -------- QR code link input / counter / state --------------------- */
  function handleQRCodeLinkInput() {
    const input = document.getElementById("qr-code-link-input");
    input.addEventListener("keyup", () => {
      const qrCodeLinkWrapper = document.querySelector(
        "#qr-code-link-variant .input-field-wrapper"
      );
      qrCodeLinkWrapper.classList.toggle(
        "variant-picked",
        input.value.trim() !== ""
      );
    });
    if (!input || input.dataset.listenerAttached) return;
    input.dataset.listenerAttached = "true";

    const counter = document.getElementById("qr-code-link-char-count");
    const error = document.getElementById("qr-code-link-error-bar");

    const MAX = 1000;

    const refresh = () => {
      const value = input.value;
      state.qr_code_link = value;
      counter.textContent = `${MAX - value.length} character(s) left`;
      error.style.display = "none";
      console.log(state);
    };

    refresh();
    input.addEventListener("input", refresh);
  }

  /* ---------- QR placement selection ---------- */
  function setupQRPlacementSelection() {
    const placementWrapper = document.getElementById(
      "qr-code-placement-variant"
    );

    placementWrapper.addEventListener("click", async (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected) return;

      placementWrapper
        .querySelectorAll(".sticker-variant")
        .forEach((el) => el.classList.toggle("active", el === selected));

      state.qr_placement = selected.dataset.placement;
      console.log("QR Placement updated to:", state.qr_placement);

      // Make sure a logo (default or user) is present
      if (!qrDesigner.logoImage) await qrDesigner.loadLogo();

      qrDesigner.updatePositions();
      await qrDesigner.mergeQRAndLogo();
    });
  }

  /* ---------------- FORM VALIDATION ---------------- */
  function validateForm() {
    let firstInvalid = null;
    function toggleError(id, show) {
      const bar = document.getElementById(id);
      if (!bar) return;

      bar.style.display = show ? "block" : "none";

      const variantBox = bar.closest(".pcs-variant");
      if (variantBox) variantBox.classList.toggle("has-error", show);

      if (show && !firstInvalid) firstInvalid = variantBox || bar;
    }

    // Logo Upload validation (only if logo upload is shown)
    const logoFieldsVisible =
      document.getElementById("horizontal-logo-fields").style.display !==
      "none";
    if (logoFieldsVisible) {
      const hasUploadedLogo = !!state.logoImage;
      toggleError("upload-file-error", !hasUploadedLogo);

      // Set error message text if missing
      const logoError = document.getElementById("upload-file-error");
      if (!hasUploadedLogo) {
        logoError.textContent =
          "Please upload a valid image file (.ai, .eps, .jpg, .png, .pdf, .tiff, .svg)";
      } else {
        logoError.textContent = ""; // Clear message
      }
    }

    // Required fields validation
    toggleError("size-quantity-error-bar", !state.size_qty);

    // QR Code specific validations (only if QR fields are visible)
    const qrFieldsVisible =
      document.getElementById("horizontal-qr-code-fields").style.display !==
      "none";
    if (qrFieldsVisible) {
      toggleError("qr-code-link-error-bar", !state.qr_code_link);
      toggleError("qr-code-placement-error-bar", !state.qr_placement);
      toggleError("base-color-error-bar", !state.base_color);
      toggleError("qr-icon-error-bar", !state.qr_icon);
    }

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }

  /* ──────────────────────────────────────────────────────────── */
  /*  PRICE LOOK-UP                                              */
  /* ──────────────────────────────────────────────────────────── */
  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }

  /* ──────────────────────────────────────────────────────────── */
  /*  RECALCULATE & RENDER TOTAL                                 */
  /* ──────────────────────────────────────────────────────────── */
  function recalcPrice() {
    let total = 0;

    total += priceOf("orientation", state.orientation);
    total += priceOf("size_qty", state.size_qty);

    const priceEl = document.getElementById("pcs-final-price");
    const prevValue = parseFloat(priceEl.textContent) || 0;
    const newValue = total;

    if (prevValue !== newValue) {
      animatePriceChange(priceEl, prevValue, newValue);
    }

    state.price = newValue;
  }

  function typeText(el, text, speed = 60) {
    return new Promise((resolve) => {
      let i = 0;
      const typeInterval = setInterval(() => {
        el.textContent += text[i];
        i++;
        if (i >= text.length) {
          clearInterval(typeInterval);
          resolve();
        }
      }, speed);
    });
  }

  function deleteText(el, speed = 40) {
    return new Promise((resolve) => {
      const delInterval = setInterval(() => {
        el.textContent = el.textContent.slice(0, -1);
        if (el.textContent.length === 0) {
          clearInterval(delInterval);
          resolve();
        }
      }, speed);
    });
  }

  // Make this async so we can await a few canvas ops safely.
  async function resetCalculatorForm() {
    // 1) Reset shared state to initial values
    Object.assign(state, {
      logoImage: null,
      editedImage: null,
      useDefaultLogo: false,
      orientation: null,                         // nothing selected yet
      size_qty: "4 Inches QTY 3 (Sample Pack)",
      design_notes: "",
      qr_code_link: "",
      qr_placement: "",                          // re-picked after orientation
      base_color: "Black",
      left_gradient: "None",
      qr_icon: "None",
      price: 0,
    });

    // 2) Reset main UI blocks
    
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    const artbox = document.getElementById("upload-artbox");
    const designerTool = document.getElementById("designerTool");
    const previewBox = document.getElementById("preview-box");
    const QRCodeContainer = document.getElementById("qr-code-container");
    const btnEditImage = document.getElementById("btnEditImage");
    const fileInput = document.querySelector("#upload-file");

    isOrientationSelected = false;
    document.getElementById("orientation-variant").querySelectorAll(".sticker-variant").forEach((el) => {
      el.classList.remove("active");
      el.classList.remove("variant-picked");
    });

    // Disable "Add to cart" until user picks orientation again
    if (addToCartBtn) addToCartBtn.disabled = true;

    // Restore upload UI
    if (artbox) artbox.style.display = "block";
    if (designerTool) {designerTool.classList.remove("active"); unlockScroll();}
    if (previewBox) previewBox.style.display = "none";
    if (QRCodeContainer) {
      QRCodeContainer.classList.remove(
        "image--inserted",
        "orientation--horizontal",
        "orientation--vertical"
      );
    }
    if (fileInput) fileInput.value = "";

    // Undo “non-editable” tweaks if they were applied
    if (btnEditImage) {
      btnEditImage.disabled = false;
      btnEditImage.textContent = "Edit Image";
    }

    // 3) Clear any error states
    document.querySelectorAll(".error-bar").forEach((el) => (el.style.display = "none"));
    document.querySelectorAll(".pcs-variant").forEach((el) => el.classList.remove("has-error"));

    // 4) Reset orientation UI (no option selected)
    const orientationWrapper = document.getElementById("orientation-variant");
    if (orientationWrapper) {
      orientationWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.remove("active", "variant-picked");
      });
    }
    // Hide the blocks that open only after picking orientation
    ["artwork-variant", "horizontal-logo-fields", "artwork-qr-code-variant", "horizontal-qr-code-fields"]
      .forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.style.display = "none";
      });

    // 5) Reset dropdowns to their defaults & sync state headers
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      dd.classList.remove("variant-picked");

      const listItems = dd.querySelectorAll("li[data-value]");
      listItems.forEach((li) => li.classList.remove("selected"));

      const header = dd.querySelector(".selected-text");
      const key = dd.dataset.stateKey;
      let defVal;

      switch (key) {
        case "size_qty":      defVal = "4 Inches QTY 3 (Sample Pack)"; break;
        case "base_color":    defVal = "Black"; break;
        case "left_gradient": defVal = "None"; break;
        case "qr_icon":       defVal = "None"; break;
        default:              defVal = listItems[0]?.dataset.value || "";
      }

      const toSelect = [...listItems].find(li => li.dataset.value === defVal) || listItems[0];
      if (toSelect) {
        toSelect.classList.add("selected");
        if (header) header.textContent = toSelect.textContent.trim();
        if (key) state[key] = toSelect.dataset.value;
      }

      const opts = dd.querySelector(".dropdown-options");
      if (opts) opts.style.display = "none";
    });

    // Also update the color & icon dropdown headers via the designer helper (keeps UI in sync)
    if (qrDesigner?.selectDropdownOption) {
      qrDesigner.selectDropdownOption("base-color-select", "Black");
      qrDesigner.selectDropdownOption("left-gradient-select", "None");
      const qrIconDd = document.getElementById("qr-icon-select");
      if (qrIconDd) {
        // clear selection text
        const st = qrIconDd.querySelector(".selected-text");
        if (st) st.textContent = "None";
      }
    }

    // 6) Reset text inputs
    const designNotesInput = document.getElementById("design-notes-input");
    if (designNotesInput) {
      designNotesInput.value = "";
      const cc = document.getElementById("design-notes-char-count");
      if (cc) cc.textContent = "1000 character(s) left";
      const wrap = document.querySelector("#design-notes-variant .input-field-wrapper");
      if (wrap) wrap.classList.remove("variant-picked");
    }

    const qrLinkInput = document.getElementById("qr-code-link-input");
    if (qrLinkInput) {
      qrLinkInput.value = "";
      const cc = document.getElementById("qr-code-link-char-count");
      if (cc) cc.textContent = "1000 character(s) left";
      const wrap = document.querySelector("#qr-code-link-variant .input-field-wrapper");
      if (wrap) wrap.classList.remove("variant-picked");
    }

    // 7) Rebuild QR placement options to match default (Horizontal, left by default)
    updateQRPlacementOptions("Horizontal"); // this also (re)binds the click handler
    state.qr_placement = "Left of Logo";

    // 8) Safely reset the Fabric preview WITHOUT destroying the instance
    try {
      // Remove any uploaded/edited logo + contour
      if (qrDesigner?.clearLogo) qrDesigner.clearLogo();

      // Designer visual defaults
      if (qrDesigner) {
        qrDesigner.baseColor = qrDesigner.colorPalette["Black"];
        qrDesigner.gradientColor = null;
        qrDesigner.applyGradient?.();

        await qrDesigner.updateIcon?.("None");
        await qrDesigner.updateOrientation?.("Horizontal"); // also handles sizing
        await qrDesigner.mergeQRAndLogo?.();                // keeps preview consistent
      }
    } catch (e) {
      console.warn("resetCalculatorForm: designer not ready", e);
    }

    // 9) Recalculate price & log
    recalcPrice();
    console.log("Calculator form has been fully reset", JSON.parse(JSON.stringify(state)));
  }

  /* ---------- Image Upload Handling ---------- */
  const artbox = document.getElementById("upload-artbox");
  const designerTool = document.getElementById("designerTool");
  const designerToolCloseBtn = document.getElementById(
    "designer-tool-close-btn"
  );
  const closeToolPopup = document.getElementById("close-tool-popup");
  const cancelCloseTool = document.getElementById("cancel-close-tool");
  const confirmCloseTool = document.getElementById("confirm-close-tool");
  const previewBox = document.getElementById("preview-box");
  const deleteImage = document.getElementById("delete-image");
  const btnEditImage = document.getElementById("btnEditImage");
  const errorMessage = document.getElementById("upload-file-error");
  const QRCodeContainer = document.getElementById("qr-code-container");

  const isNonEditableUpload = (file) => {
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    // Treat TIFF (image/tiff) as non-editable even though it's an image/*
    return NON_EDITABLE_EXTS.includes(ext) || file.type === "application/pdf";
  };

  function fileInputChangeHandler(fileInput) {
    const chooseFileBtn = document.getElementById("choose-file-btn");

    chooseFileBtn.onclick = null;
    chooseFileBtn.addEventListener("click", () => {
      fileInput.value = "";
      fileInput.click();
    });

    btnEditImage.addEventListener("click", () => {
      designerTool.classList.add("active");
      lockScroll();
    });

    fileInput.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const img = document.querySelector("#preview-image");
      const reader = new FileReader();

      // 🚫 Kill any stale handlers from previous uploads
      img.onload = null;
      img.onerror = null;

      if (!fileInput.files.length && !emailLaterCheckbox.checked) {
        addToCartBtn.disabled = true;
      } else {
        addToCartBtn.disabled = false;
        setTimeout(() => addToCartBtn.classList.add("shine"), 1000);
        setTimeout(() => addToCartBtn.classList.remove("shine"), 2000);
      }

      // ✅ Non-editable uploads
      if (isNonEditableUpload(file)) {
        state.logoImage = file;
        state.editedImage = "";
        state.useDefaultLogo = true;

        artbox.style.display = "none";
        previewBox.style.display = "block";
        QRCodeContainer.classList.add("image--inserted");

        // make sure editor stays closed and no handler fires
        designerTool.classList.remove("active");
        unlockScroll();
        img.onload = null;
        img.onerror = null;
        const ext = file.name.split(".").pop().toLowerCase();

        // pick icon if we have one
        const iconSrc = FORMAT_ICONS[ext] || FORMAT_ICONS.default;

        // show it
        img.src = iconSrc;
        previewBox.classList.add("non-editable-image");

        document.getElementById("width-inch").textContent = "";
        document.getElementById("height-inch").textContent = "";

        btnEditImage.disabled = true;
        btnEditImage.textContent = "Editing not available for this file type";

        const nonEditableNote = document.getElementById("noneditable-note");
        if (nonEditableNote) {
          nonEditableNote.textContent =
            "This file type can’t be edited in the browser. We’ll use it as provided.";
        }

        errorMessage.classList.remove("active");
        recalcPrice();

        setTimeout(async (e)=>{
          qrDesigner.clearLogo();
          await qrDesigner.mergeQRAndLogo();
        }, 50)

        const targetElement = document.getElementById("size-quantity-variant");
        const stickyHeaderOffset = -81;
        const targetScrollPosition =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset +
          stickyHeaderOffset;

        const sizeQuantitySelect = document.getElementById(
          "size-quantity-select"
        );
        blinkVariantElement(sizeQuantitySelect);

        window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });
        return;
      } else {
        state.useDefaultLogo = false;
        btnEditImage.disabled = false;
        btnEditImage.textContent = "Edit Image Again";
        const nonEditableNote = document.getElementById("noneditable-note");
        if (nonEditableNote) nonEditableNote.textContent = "";
        previewBox.classList.remove("non-editable-image");
      }

      // Validate file type
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
        "application/pdf",
      ];
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(ai|eps|tiff)$/i)) {
        errorMessage.classList.add("active");
        errorMessage.textContent =
          "Please upload a valid image file (.ai, .eps, .jpg, .png, .pdf, .tiff, .svg)";
        fileInput.value = "";
        return;
      }

      reader.onload = async (e) => {
        const tempImg = new Image();
        tempImg.src = e.target.result;

        tempImg.onload = async () => {
          const width = tempImg.naturalWidth;
          const height = tempImg.naturalHeight;

          if (width < 300 || height < 300) {
            errorMessage.classList.add("active");
            errorMessage.textContent =
              "Please upload an image with at least 300x300 pixels.";
            fileInput.value = "";
            return;
          }

          // Attach a one-time load handler so it can't linger to future loads
          img.addEventListener(
            "load",
            async () => {
              try {
                console.log("Dropping in img.onload");

                artbox.style.display = "none";
                previewBox.style.display = "block";
                QRCodeContainer.classList.add("image--inserted");

                designerTool.classList.add("active");
                lockScroll();
                errorMessage.classList.remove("active");

                state.logoImage = file;
                state.useDefaultLogo = false;

                setTimeout(async (e)=>{
                  qrDesigner.clearLogo();
                  await qrDesigner.mergeQRAndLogo();
                }, 50)

                recalcPrice();
                console.log("Image uploaded successfully:", file.name);
              } catch (error) {
                console.error("Error processing image:", error);
                errorMessage.classList.add("active");
                errorMessage.textContent =
                  "An error occurred while processing the image.";
                fileInput.value = "";
              }
            },
            { once: true }
          );

          // Set src *after* the one-time handler is attached
          img.src = e.target.result;
        };

        tempImg.onerror = () => {
          errorMessage.classList.add("active");
          errorMessage.textContent =
            "Failed to load image. It might be corrupted.";
          fileInput.value = "";
        };
      };

      reader.onerror = () => {
        errorMessage.classList.add("active");
        errorMessage.textContent = "Failed to read file.";
        fileInput.value = "";
      };

      reader.readAsDataURL(file);
    };
  }

  // **Delete image handler**
  deleteImage.addEventListener("click", (e) => {
    // Show upload area and hide preview
    artbox.style.display = "block";
    designerTool.classList.remove("active");
    unlockScroll();
    QRCodeContainer.classList.remove("image--inserted");
    previewBox.style.display = "none";
    previewBox.classList.remove("non-editable-image");
    errorMessage.classList.remove("active");
    // Reset state
    state.logoImage = null;
    state.editedImage = null;
    state.useDefaultLogo = true;
    
    // Clear file input
    const fileInput = document.querySelector("#upload-file");
    if (fileInput) fileInput.value = "";
    // Reset price to base price
    recalcPrice();
    qrDesigner.clearLogo();
    qrDesigner.loadLogo();
    qrDesigner.mergeQRAndLogo();
    console.log("isFromFinishEditing: ", isFromFinishEditing);
  });

  // designerToolCloseBtn.addEventListener("click", (e) => {
  //   closeToolPopup.classList.add("active");
  // });

  cancelCloseTool.addEventListener("click", (e) => {
    closeToolPopup.classList.remove("active");
  });

  confirmCloseTool.addEventListener("click", (e) => {
    closeToolPopup.classList.remove("active");
    deleteImage.click();
  });

  function setupApippaAddToCart() {
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }
      console.log("Form valid – adding to cart:", state);

      /* UI: show loader */
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
        <div class="pcs-loader"></div>
        <p class="pcs-message"></p>
        <div class="dot-falling"></div>
      `;
      const messageEl = addToCartBtn.querySelector(".pcs-message");

      // Looping text messages
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;

      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await deleteText(messageEl);
          messageIndex++;
        }
      };

      startTypingLoop();

      const loadingBar = addToCartBtn.querySelector(".pcs-loader");
      let progress = 0;
      const target = 99;

      const interval = setInterval(() => {
        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }
        loadingBar.style.transform = `scaleX(${Math.floor(progress)}%)`;
      }, 80);

      try {
        const qrCanvas = document.getElementById("qr-code-preview");
        let qrCodeImageFile = null;

        if (qrCanvas) {
          // Convert canvas to blob
          const blob = await new Promise((resolve) => {
            qrCanvas.toBlob(resolve, "image/png");
          });

          // Convert blob to file
          qrCodeImageFile = new File([blob], "qr-code.png", {
            type: "image/png",
          });
        }

        /* Build Apippa payload */
        const requestData = {
          calculatorId: "4fa4445d36dc4", // Replace with your calculator ID
          productId: 7707558772784, // Replace with your product ID
          properties: {
            "Upload Image": state.logoImage,
            "Edited Image": state.editedImage,
            "QR Code Image": qrCodeImageFile,
            Orientation: state.orientation,
            "Size & Quantity": state.size_qty,
            "Design Notes / Reorder Number": state.design_notes || "",
            "QR Code Link": state.qr_code_link || "",
            "QR Code Placement": state.qr_placement,
            "Base Color": state.base_color,
            "Left Gradient Color": state.left_gradient,
            "QR Code Icon": state.qr_icon,
          },
        };

        console.log("Request Data: ", requestData)

        /* Create/fetch the variant via Apippa */
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          }
        );

        const variantId = await variantRes.json();
        console.log("Variant Id: ", variantId);
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;

        if (!shopifyVariantId) throw new Error("Invalid variant ID");

        /* Add variant to Shopify cart */
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);

        // Add properties
        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });

        // Handle file upload if exists
        // const fileInput = document.getElementById("upload-logo");
        // if (fileInput.files.length > 0) {
        //   formData.append("properties[Uploaded Logo]", fileInput.files[0]);
        // }

        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        const cartAddJson = await cartAddRes.json();
        console.log("Add to Cart Response:", cartAddJson);

        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          })
        );

        if (!cartAddRes.ok) throw new Error("Failed to add to cart");

        // Refresh mini-cart
        const cartJson = {
          items: [cartAddJson],
          item_count: 1,
          total_price: cartAddJson.final_price,
          original_total_price: cartAddJson.original_price,
          total_discount: 0,
        };

        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((res) => res.text());

        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  ...cartJson,
                  sections: {
                    "mini-cart": miniCartHTML,
                  },
                },
                openMiniCart: true,
              },
            })
          );
        }

        // Update cart count
        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);

        // Add confetti animation
        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content"
          );
          if (!drawerContent) return;

          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("direction", "1");
          confetti.setAttribute("playmode", "normal");
          confetti.setAttribute("autoplay", "");

          drawerContent.prepend(confetti);

          setTimeout(() => {
            confetti.remove();
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = "Add to Cart";
        resetCalculatorForm();
      }
    });
  }

  // Initialize all functionality
  setupOrientationSelection();
  initDropdownDefaults();
  document.addEventListener("click", dropdownClickHandler);
  const fileInput = document.querySelector("#upload-file");
  fileInputChangeHandler(fileInput);
  handleDesignNotesInput();
  handleQRCodeLinkInput();
  setupQRPlacementSelection();
  updateQRPlacementOptions("Horizontal");
  setupApippaAddToCart();
  recalcPrice(); // Initialize price display

  // -- StickerDesigner CLASS --
  class StickerDesigner {
    constructor() {
      this.canvas = new fabric.Canvas("stickerCanvas");
      this.uploadedImage = null;
      this.originalImageFile = null;
      this.clipPath = null;
      this.currentShape = null;
      this.guidelines = null;
      this.tireBoxes = [];

      this.lastValidShape = "Square"; // Changed from "Skateboard"

      // We'll store the contour object here for re-aligning on AutoAdjust
      this.contourObj = null;
      this.icons = {
        resizeLeft:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/resize-left.png",
        resizeRight:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/resize-right.png",
      };

      this.init();
    }

    init() {
      this.setupCanvas();
      this.setupEventListeners();
      this.setupCustomControls();
      this.updateCanvasSize();
    }

    // -------------------------------------------------------------
    // 1) Basic Canvas Setup
    // -------------------------------------------------------------
    setupCanvas() {
      this.canvas.controlsAboveOverlay = true;
      this.canvas.selection = false;
      this.canvas.preserveObjectStacking = true;
    }

    setupEventListeners() {
      // Window resize
      $(window).on("resize", () => this.handleResize());

      // File input => user uploads
      $("#upload-file").on("change", (e) => {
        this.handleImageUpload(e);
      });

      $("#toggleGuides").on("change", (e) => {
        const visible = e.target.checked;
        this.toggleGuidelines(visible);
      });

      // Auto adjust
      $("#autoAdjust").on("click", () => this.handleAutoAdjust());

      $("#zoomRange").on("input", (e) =>
        this.setZoom(parseFloat(e.target.value))
      );

      $(".align-btn").on("click", (e) => {
        const alignType = $(e.currentTarget).data("align");
        this.alignUploadedImage(alignType);
      });

      // Finish Editing
      $("#finishEditing").on("click", () => this.finishEditing());

      // Remove image
      $("#confirm-close-tool").on("click", () => this.handleRemoveImage());
    }

    handleResize() {
      this.updateCanvasSize();
      if (this.uploadedImage && this.clipPath) {
        // Recreate non-contour shapes on resize
        if (this.currentShape !== "Contour-Cut") {
          this.drawClipPath(this.currentShape);
        }
        this.centerObjects();
        this.resizeImageToFitClipPath();
      }
      this.canvas.renderAll();
    }

    setZoom(scale) {
      if (!this.uploadedImage) return;

      this.uploadedImage.scaleX = scale;
      this.uploadedImage.scaleY = scale;

      this.centerImage();
      this.canvas.renderAll();
    }

    updateCanvasSize() {
      const container = $("#canvasContainer");
      this.canvas.setWidth(container.width());
      this.canvas.setHeight(container.height());
      this.canvas.renderAll();
    }

    // -------------------------------------------------------------
    // 2) Custom Controls (corner icons) -- optional
    // -------------------------------------------------------------
    setupCustomControls() {
      // Preload corner icons if you want custom icons
      const resizeLeftImg = new Image();
      resizeLeftImg.src = this.icons.resizeLeft;

      const resizeRightImg = new Image();
      resizeRightImg.src = this.icons.resizeRight;

      // Apply once they load
      resizeLeftImg.onload = () =>
        this.applyCustomCornerIcons(resizeLeftImg, resizeRightImg);
      resizeRightImg.onload = () =>
        this.applyCustomCornerIcons(resizeLeftImg, resizeRightImg);

      // Basic styling
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "black";
      fabric.Object.prototype.borderColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    applyCustomCornerIcons(iconLeft, iconRight) {
      const renderIcon = (icon) => {
        return function (ctx, left, top, _styleOverride, fabricObject) {
          const size = this.cornerSize;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(icon, -size / 2, -size / 2, size, size);
          ctx.restore();
        };
      };

      const setCustomControl = (controlKey, options) => {
        const ctrl = fabric.Object.prototype.controls[controlKey];
        if (ctrl) Object.assign(ctrl, options);
      };

      // Example overrides for corners
      const controlSettings = {
        tl: { render: renderIcon(iconLeft), cornerSize: 30 },
        tr: { render: renderIcon(iconRight), cornerSize: 30 },
        bl: { render: renderIcon(iconRight), cornerSize: 30 },
        br: { render: renderIcon(iconLeft), cornerSize: 30 },
      };

      Object.entries(controlSettings).forEach(([k, opt]) =>
        setCustomControl(k, opt)
      );

      // Hide other mid controls
      fabric.Object.prototype.setControlsVisibility({
        mt: false,
        ml: false,
        mr: false,
        mb: false,
      });
    }

    // -------------------------------------------------------------
    // 3) Image Upload Logic
    // -------------------------------------------------------------
    async handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // if (!this.validateImageFile(file)) return;

      $("#image-upload-label").css("display", "none");
      $("#filename").css("display", "flex");
      $("#filename span").text(file.name);

      // ✅ Reset the entire canvas & remove previous objects
      this.canvas.clear();
      this.uploadedImage = null;
      this.clipPath = null;
      this.contourObj = null;
      this.currentShape = null;

      this.originalImageFile = file; // Save new file reference

      // ✅ Reset contour settings to defaults
      this.contourBorderThickness = 90; // Default small contour
      this.marginPercent = 0.06; // Default margin factor

      // ✅ Enable UI options
      $("#finishEditing").prop("disabled", false);
      $("#autoAdjust").prop("disabled", false);
      $("#remove").prop("disabled", false);

      try {
        let imgObj = await this.loadImageFile(file);

        // 🚀 **Check if cropping is needed before applying it**
        const croppedImg = await this.cropTransparentAreas(imgObj);
        if (croppedImg) {
          imgObj = croppedImg; // Use cropped image if gaps were found
        }

        this.uploadedImage = imgObj;
        this.centerImage();

        // ✅ **Draw default shape ("Square") and fit the new image inside it**
        this.drawClipPath();

        // ✅ **Select the uploaded image by default**
        this.uploadedImage.set({
          hasControls: true,
          hasBorders: true,
          selectable: true,
        });
        this.canvas.setActiveObject(this.uploadedImage);
        this.canvas.renderAll();
      } catch (err) {
        this.showError("Image load failed. Please try a different file.");
        this.handleRemoveImage();
      }
    }

    async cropTransparentAreas(imgObj, alphaThreshold = 30, padding = 2.5) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = imgObj.width;
        canvas.height = imgObj.height;

        const tempImg = new Image();
        tempImg.src = imgObj.toDataURL("image/png"); // Preserve transparency
        tempImg.onload = () => {
          ctx.drawImage(tempImg, 0, 0);

          // Get pixel data
          const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const pixels = imgData.data;

          let minX = canvas.width,
            minY = canvas.height,
            maxX = 0,
            maxY = 0;

          // Loop through pixels to find actual content
          for (let y = 0; y < canvas.height; y++) {
            for (let x = 0; x < canvas.width; x++) {
              const index = (y * canvas.width + x) * 4;
              const r = pixels[index];
              const g = pixels[index + 1];
              const b = pixels[index + 2];
              const alpha = pixels[index + 3];

              // Updated condition: Consider pixel as content if opaque AND not near-white
              // Tolerance of 240 handles slight variations from compression/artifacts
              if (
                alpha > alphaThreshold &&
                !(r >= 240 && g >= 240 && b >= 240)
              ) {
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
              }
            }
          }

          // ✅ Check if image has extra gaps
          const hasExtraGap =
            minX > padding ||
            minY > padding ||
            maxX < canvas.width - padding ||
            maxY < canvas.height - padding;

          // ❌ If no extra gaps, return nothing (null)
          if (!hasExtraGap) {
            resolve(null);
            return;
          }

          // ✅ **Apply a small padding to avoid harsh cuts**
          minX = Math.max(0, minX - padding);
          minY = Math.max(0, minY - padding);
          maxX = Math.min(canvas.width, maxX + padding);
          maxY = Math.min(canvas.height, maxY + padding);

          const newWidth = maxX - minX;
          const newHeight = maxY - minY;

          // Create a new canvas for the cropped image
          const croppedCanvas = document.createElement("canvas");
          const croppedCtx = croppedCanvas.getContext("2d");
          croppedCanvas.width = newWidth;
          croppedCanvas.height = newHeight;

          // ✅ **Apply a soft blur to smooth edges slightly**
          croppedCtx.filter = "blur(0.3px)";
          croppedCtx.drawImage(
            canvas,
            minX,
            minY,
            newWidth,
            newHeight,
            0,
            0,
            newWidth,
            newHeight
          );

          // Convert back to Fabric.js image
          fabric.Image.fromURL(
            croppedCanvas.toDataURL("image/png"),
            (croppedImg) => {
              resolve(croppedImg);
            }
          );
        };

        tempImg.onerror = reject;
      });
    }

    // validateImageFile(file) {
    //   const validTypes = ["image/png", "image/jpeg"];
    //   const maxSize = 5 * 1024 * 1024; // 5MB

    //   if (!validTypes.includes(file.type)) {
    //     this.showError("Invalid file type. Please upload PNG or JPEG.");
    //     return false;
    //   }
    //   if (file.size > maxSize) {
    //     this.showError("File size exceeds 5MB limit.");
    //     return false;
    //   }
    //   return true;
    // }

    loadImageFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          fabric.Image.fromURL(
            e.target.result,
            (img) => {
              // Get Canvas Dimensions
              const canvasWidth = this.canvas.width;
              const canvasHeight = this.canvas.height;

              // Minimum recommended resolution
              const minWidth = 500; // Adjust as needed
              const minHeight = 500; // Adjust as needed

              // Check if the image is low resolution
              if (img.width < minWidth || img.height < minHeight) {
                this.showWarning(
                  `Low resolution detected: ${img.width}x${img.height}px. 
                            This may affect print quality. Consider using a higher-resolution image.`
                );
              } else {
                $("#canvasMessage").hide(); // Hide any previous warnings
              }

              // Calculate Scaling Factor
              const scaleX = canvasWidth / img.width;
              const scaleY = canvasHeight / img.height;
              const scale = Math.min(scaleX, scaleY, 1); // Prevent Upscaling

              // Apply Scaling
              img.scale(scale);

              // Center the Image
              img.set({
                originX: "center",
                originY: "center",
                left: canvasWidth / 2,
                top: canvasHeight / 2,
              });

              resolve(img);
            },
            { crossOrigin: "anonymous" }
          ); // Fix potential CORS issues
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    clearCanvas() {
      this.canvas.clear();
      this.canvas.clipPath = null;
      this.clipPath = null;
      this.guidelines = null;
      this.contourObj = null;
    }

    toggleGuidelines(visible) {
      if (this.guidelineObjects) {
        this.guidelineObjects.forEach((obj) => {
          obj.visible = visible;
        });
      }

      if (this.tireBoxes) {
        this.tireBoxes.forEach((box) => {
          box.visible = visible;
        });
      }

      this.canvas.renderAll();
    }

    addImageToCanvas() {
      if (this.uploadedImage) {
        this.canvas.add(this.uploadedImage);
      }
    }

    /**
     * Draw the user-selected shape as the new clip path.
     * Also handles "Contour-Cut".
     */
    async drawClipPath() {
      this.clearCanvas();

      // draw base and set clipPath
      this.createSquare();

      // ✅ add outlines
      if (this.guidelineObjects?.length) {
        this.guidelineObjects.forEach((obj) => {
          this.canvas.add(obj);
        });
      }

      this.resizeImageToFitClipPath?.();
      this.applyClipPathListeners?.();
    }

    createSquare() {
      // Define a simple square path
      const squarePath = `
        M0,0
        L300,0
        L300,300
        L0,300
        Z
      `;

      const patternCanvas = document.createElement("canvas");
      patternCanvas.width = 20;
      patternCanvas.height = 20;
      const patternCtx = patternCanvas.getContext("2d");
      patternCtx.fillStyle = "rgba(200, 200, 200, 0.5)";
      patternCtx.fillRect(0, 0, 10, 10);
      patternCtx.fillRect(10, 10, 10, 10);

      const pattern = new fabric.Pattern({
        source: patternCanvas,
        repeat: "repeat",
      });

      const pathObj = new fabric.Path(squarePath, {
        fill: pattern,
        stroke: "rgba(0,0,0,0)",
        selectable: false,
        evented: false,
        originX: "center",
        originY: "center",
        objectCaching: false,
        id: "clipPathPattern",
      });

      const baseScale =
        0.9 *
        Math.min(
          this.canvas.width / pathObj.width,
          this.canvas.height / pathObj.height
        );

      pathObj.set({
        scaleX: baseScale,
        scaleY: baseScale,
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
      });

      this.clipPath = pathObj;

      // ▓▓▓ Guidelines
      const showGuidelines = $("#toggleGuides").prop("checked");
      this.guidelineObjects = [];

      if (showGuidelines) {
        const guidelineStyles = [
          // { stroke: "#ec008c", dash: [6, 3], offset: 0.86 },
          // { stroke: "#00c853", dash: [], offset: 0.89 },
          // { stroke: "#29b6f6", dash: [], offset: 0.92 },
          // { stroke: "#ba68c8", dash: [], offset: 0.94 },
          // { stroke: "#43a047", dash: [], offset: 0.955 },
          // { stroke: "#039be5", dash: [], offset: 0.975 },
          { stroke: "#ec008c", dash: [], offset: 1.0 },
        ];

        guidelineStyles.forEach((style) => {
          const guide = new fabric.Path(squarePath, {
            fill: "",
            stroke: style.stroke,
            strokeWidth: 1,
            strokeDashArray: style.dash,
            strokeUniform: true,
            originX: "center",
            originY: "center",
            selectable: false,
            evented: false,
            objectCaching: false,
          });

          guide.set({
            scaleX: baseScale * style.offset,
            scaleY: baseScale * style.offset,
            left: this.canvas.width / 2,
            top: this.canvas.height / 2,
          });

          this.guidelineObjects.push(guide);
        });
      }

      // ▓▓▓ Add all elements
      this.canvas.add(this.clipPath);
      if (this.uploadedImage) {
        this.canvas.add(this.uploadedImage);
      }

      this.guidelineObjects.forEach((g) => this.canvas.add(g));

      // ▓▓▓ Dimming Overlay (the effect you want)
      if (this.uploadedImage && this.clipPath) {
        // Remove existing overlay if any
        if (this.overlayMask) {
          this.canvas.remove(this.overlayMask);
          this.overlayMask = null;
        }

        const overlay = new fabric.Rect({
          width: this.canvas.getWidth(),
          height: this.canvas.getHeight(),
          left: 0,
          top: 0,
          fill: "rgba(255,255,255,0.75)",
          selectable: false,
          evented: false,
        });

        const hole = new fabric.Path(squarePath, {
          originX: "center",
          originY: "center",
          scaleX: baseScale,
          scaleY: baseScale,
          left: this.canvas.width / 2,
          top: this.canvas.height / 2,
        });
        hole.absolutePositioned = true;

        overlay.clipPath = new fabric.Group([hole], {
          inverted: true,
          absolutePositioned: true,
        });

        this.overlayMask = overlay;
        this.canvas.add(overlay);
        overlay.bringToFront();
      }

      // ▓▓▓ Finalize
      this.guidelineObjects.forEach((el) => el.bringToFront());
      if (this.overlayMask) this.overlayMask.bringToFront();

      this.resizeImageToFitClipPath();
      this.applyClipPathListeners();
    }

    applyClipPathListeners() {
      if (!this.canvas.clipPath) return; // ✅ Prevents errors if clipPath is null

      // ✅ Remove previous event bindings to prevent duplicates
      this.canvas.clipPath.off("mouseover mouseout");
      this.canvas.off("mouse:down");

      // ✅ Ensure `.isSelected` property exists
      this.canvas.clipPath.isSelected = false;

      // ✅ Hover effect: Change stroke color on hover
      this.canvas.clipPath.on("mouseover", () => {
        if (!this.canvas.clipPath.isSelected) {
          this.canvas.clipPath.set("stroke", "#000000");
          this.canvas.renderAll();
        }
      });

      this.canvas.clipPath.on("mouseout", () => {
        if (!this.canvas.clipPath.isSelected) {
          this.canvas.clipPath.set("stroke", "darkgrey");
          this.canvas.renderAll();
        }
      });

      // ✅ Handle click selection behavior
      this.canvas.on("mouse:down", (event) => {
        if (!this.canvas.clipPath) return;

        if (event.target === this.canvas.clipPath) {
          // ✅ Select clipPath
          this.canvas.clipPath.set({
            hasControls: true,
            hasBorders: true,
            stroke: "#ec008c",
          });
          this.canvas.clipPath.isSelected = true;
          if (this.uploadedImage) {
            this.uploadedImage.set({
              hasControls: false,
              hasBorders: false,
            });
          }
        } else if (event.target === this.uploadedImage) {
          // ✅ Select uploaded image
          this.uploadedImage.set({
            hasControls: true,
            hasBorders: true,
          });
          this.canvas.clipPath.set({
            hasControls: false,
            hasBorders: false,
            stroke: "darkgrey",
          });
          this.canvas.clipPath.isSelected = false;
          this.canvas.setActiveObject(this.uploadedImage);
        } else {
          // ✅ Deselect both if clicked outside
          this.canvas.clipPath.set({
            hasControls: false,
            hasBorders: false,
            stroke: "darkgrey",
          });
          this.canvas.clipPath.isSelected = false;
          if (this.uploadedImage) {
            this.uploadedImage.set({
              hasControls: false,
              hasBorders: false,
            });
          }
        }
        this.canvas.renderAll();
      });
    }

    // -------------------------------------------------------------
    // 7) Resize & Center Logic
    // -------------------------------------------------------------
    resizeImageToFitClipPath() {
      if (!this.uploadedImage || !this.clipPath) return;

      let availableWidth, availableHeight;

      if (this.clipPath instanceof fabric.Circle) {
        availableWidth = this.clipPath.radius * 2; // Remove the extra padding
        availableHeight = this.clipPath.radius * 2;
      } else {
        const clipRect = this.clipPath.getBoundingRect(true);
        availableWidth = clipRect.width; // Remove the extra padding
        availableHeight = clipRect.height;
      }

      // Calculate scaling factors to fit the image within available space
      const scaleX = availableWidth / this.uploadedImage.width;
      const scaleY = availableHeight / this.uploadedImage.height;

      // Use Math.min to ensure the image fits entirely within the bounds
      const targetScale = Math.min(scaleX, scaleY);

      this.uploadedImage.scale(targetScale);
      $("#zoomRange").val(this.uploadedImage.scaleX.toFixed(2));
      this.centerObjects();
    }

    centerImage() {
      if (!this.uploadedImage) return;
      this.uploadedImage.set({
        originX: "center",
        originY: "center",
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
      });
      this.canvas.renderAll();
    }

    centerObjects() {
      [this.uploadedImage, this.clipPath].forEach((obj) => {
        if (obj) {
          obj.set({
            originX: "center",
            originY: "center",
            left: this.canvas.width / 2,
            top: this.canvas.height / 2,
          });
          obj.setCoords();
        }
      });
      this.canvas.renderAll();
    }

    alignUploadedImage(direction) {
      if (!this.uploadedImage) return;

      const img = this.uploadedImage;
      const canvasW = this.canvas.getWidth();
      const canvasH = this.canvas.getHeight();

      // Use bounding box of clipPath if available
      let bounds = this.clipPath
        ? this.clipPath.getBoundingRect(true)
        : { left: 0, top: 0, width: canvasW, height: canvasH };

      switch (direction) {
        case "left":
          img.left = bounds.left + img.getScaledWidth() / 2;
          break;
        case "centerH":
          img.left = bounds.left + bounds.width / 2;
          break;
        case "right":
          img.left = bounds.left + bounds.width - img.getScaledWidth() / 2;
          break;
        case "top":
          img.top = bounds.top + img.getScaledHeight() / 2;
          break;
        case "centerV":
          img.top = bounds.top + bounds.height / 2;
          break;
        case "bottom":
          img.top = bounds.top + bounds.height - img.getScaledHeight() / 2;
          break;
      }

      img.setCoords();
      this.canvas.renderAll();
    }

    // -------------------------------------------------------------
    // 8) Button Handlers
    // -------------------------------------------------------------
    handleAutoAdjust() {
      if (!this.uploadedImage) return;

      if (this.clipPath) {
        // For other shapes, just re-run the standard resize logic
        this.centerImage();
        this.resizeImageToFitClipPath();
      }
      this.canvas.renderAll();
    }

    async finishEditing() {
      if (!this.uploadedImage || !this.clipPath) {
        this.showError(
          "Please upload an image and ensure the clipPath exists."
        );
        return;
      }

      const hideList = [];

      // Hide guides for clean version
      if (this.guidelineObjects) {
        this.guidelineObjects.forEach((g) => {
          hideList.push(g);
          g.visible = false;
        });
      }

      this.canvas.renderAll();

      try {
        // Get the clean clipped image data URL
        const cleanDataURL = await this.getClippedImageDataURL();

        // Convert data URL to Blob
        const blob = await (await fetch(cleanDataURL)).blob();

        // Create a File object from the Blob
        const file = new File([blob], "custom-square.png", {
          type: "image/png",
        });

        // Update the state with the edited image
        state.editedImage = file;

        setTimeout(async (e)=>{
          qrDesigner.clearLogo();
          await qrDesigner.mergeQRAndLogo();
        }, 50)

        // Update the preview image
        const previewImg = document.getElementById("preview-image");
        isFromFinishEditing = true;
        previewImg.src = cleanDataURL;

        // Calculate dimensions from the final clipped image
        const img = new Image();
        img.src = cleanDataURL;

        await new Promise((resolve) => {
          img.onload = resolve;
        });

        // Calculate dimensions in inches (assuming 72 DPI)
        const widthInches = parseInt(img.width / 72);
        const heightInches = parseInt(img.height / 72);

        document.getElementById("width-inch").textContent = `${widthInches}"`;
        document.getElementById("height-inch").textContent = `${heightInches}"`;

        console.log("Image editing completed and saved to state");
      } catch (err) {
        console.error("Error saving edited image:", err);
        this.showError("Failed to save edited image. Please try again.");
      } finally {
        // Hide the designer tool and show the preview
        $("#designerTool").removeClass("active");
        unlockScroll();
        $("#preview-box").css("display", "block");
        $("#upload-artbox").css("display", "none");

        const targetElement = document.getElementById("size-quantity-variant");
        const stickyHeaderOffset = -81;
        const targetScrollPosition =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset +
          stickyHeaderOffset;

        const sizeQuantitySelect = document.getElementById(
          "size-quantity-select"
        );
        blinkVariantElement(sizeQuantitySelect);

        window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });

        // Restore guides visibility
        hideList.forEach((obj) => (obj.visible = true));
        this.canvas.renderAll();
      }
    }

    // Helper function to get clipped image data URL
    getClippedImageDataURL() {
      return new Promise((resolve) => {
        const tempCanvas = new fabric.Canvas(null, {
          width: this.canvas.getWidth(),
          height: this.canvas.getHeight(),
          backgroundColor: "transparent",
        });

        const clonePromises = this.canvas
          .getObjects()
          .filter((obj) => obj.visible && obj.id !== "clipPathPattern")
          .map((obj) => {
            return new Promise((resolve) =>
              obj.clone((cloned) => {
                cloned.set({ opacity: 1 });
                resolve(cloned);
              })
            );
          });

        Promise.all(clonePromises).then((clonedObjects) => {
          clonedObjects.forEach((clone) => tempCanvas.add(clone));

          this.clipPath.clone((clonedClip) => {
            clonedClip.absolutePositioned = true;
            tempCanvas.clipPath = clonedClip;

            tempCanvas.renderAll();

            const fullDataURL = tempCanvas.toDataURL({
              format: "png",
              multiplier: 2,
            });

            // 👉 Now remove transparent borders from the final PNG
            cropTransparentImage(fullDataURL).then((croppedDataURL) => {
              resolve(croppedDataURL);
            });
          });
        });
      });
    }

    handleRemoveImage() {
      // ✅ Clear the uploaded image and reset file input
      this.uploadedImage = null;
      this.clipPath = null;
      this.contourObj = null;
      this.currentShape = null;
      this.originalImageFile = null;

      // ✅ Clear the canvas
      this.canvas.clear();
      this.canvas.clipPath = null;

      // ✅ Restore the upload button UI
      $("#image-upload-label").css("display", "flex");
      $("#filename").css("display", "none");

      // ✅ Reset the file input
      $("#ImageUpload").val("");

      // ✅ Disable UI options
      $("#finishEditing").prop("disabled", true);
      $("#autoAdjust").prop("disabled", true);
      $("#remove").prop("disabled", true);
      $("#smallContour").prop("disabled", true);
      $("#mediumContour").prop("disabled", true);
      $("#largeContour").prop("disabled", true);
      $("#canvasMessage").text("");
      $("#canvasMessage").css("display", "none");

      qrDesigner.clearLogo();
    }

    // -------------------------------------------------------------
    // 9) Utility - show messages
    // -------------------------------------------------------------
    showError(message) {
      const msgEl = $("#canvasMessage");
      msgEl.removeClass("warning").addClass("error").text(message).fadeIn();
    }

    showWarning(message) {
      const msgEl = $("#canvasMessage");
      msgEl.removeClass("error").addClass("warning").text(message).fadeIn();
    }
  }

  function blinkVariantElement(element) {
    if (!element) return;

    const hasVariantClass =
      element.classList.contains("variant-picked") ||
      element.classList.contains("artwork-box");
    const blinkClass = hasVariantClass
      ? "no-border-variant-blink"
      : "border-variant-blink";

    let blinkCount = 0;
    const maxBlinks = 4; // 3 on/off cycles
    const blinkInterval = 300; // milliseconds

    const intervalId = setInterval(() => {
      element.classList.toggle(blinkClass);
      blinkCount++;

      if (blinkCount >= maxBlinks) {
        clearInterval(intervalId);
        element.classList.remove(blinkClass); // Ensure it's removed after blinking
      }
    }, blinkInterval);
  }

  // Global function at the bottom...

  function cropTransparentImage(dataURL, alphaThreshold = 30, padding = 0) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = dataURL;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const pixels = imageData.data;

        let minX = canvas.width,
          minY = canvas.height,
          maxX = 0,
          maxY = 0;

        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const index = (y * canvas.width + x) * 4;
            const r = pixels[index];
            const g = pixels[index + 1];
            const b = pixels[index + 2];
            const alpha = pixels[index + 3];

            // Updated condition: Consider pixel as content if opaque AND not near-white
            // Tolerance of 240 handles slight variations from compression/artifacts
            if (alpha > alphaThreshold && !(r >= 240 && g >= 240 && b >= 240)) {
              minX = Math.min(minX, x);
              minY = Math.min(minY, y);
              maxX = Math.max(maxX, x);
              maxY = Math.max(maxY, y);
            }
          }
        }

        if (minX > maxX || minY > maxY) {
          resolve(dataURL); // No visible pixels, return original
          return;
        }

        // Add padding
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(canvas.width, maxX + padding);
        maxY = Math.min(canvas.height, maxY + padding);

        const croppedWidth = maxX - minX;
        const croppedHeight = maxY - minY;

        const croppedCanvas = document.createElement("canvas");
        const croppedCtx = croppedCanvas.getContext("2d");
        croppedCanvas.width = croppedWidth;
        croppedCanvas.height = croppedHeight;

        croppedCtx.drawImage(
          canvas,
          minX,
          minY,
          croppedWidth,
          croppedHeight,
          0,
          0,
          croppedWidth,
          croppedHeight
        );

        resolve(croppedCanvas.toDataURL("image/png"));
      };

      img.onerror = () => {
        console.error("Failed to load image for cropping");
        resolve(dataURL); // Fallback
      };
    });
  }

  // Finally, instantiate the class
  new StickerDesigner();
});
